/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tame_Flat_Mule_WeepInputs */

const en_tame_flat_mule_weep = /** @type {(inputs: Tame_Flat_Mule_WeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peer Feedback`)
};

const de_tame_flat_mule_weep = /** @type {(inputs: Tame_Flat_Mule_WeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peer-Feedback`)
};

/**
* | output |
* | --- |
* | "Peer Feedback" |
*
* @param {Tame_Flat_Mule_WeepInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tame_flat_mule_weep = /** @type {((inputs?: Tame_Flat_Mule_WeepInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tame_Flat_Mule_WeepInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tame_flat_mule_weep(inputs)
	return de_tame_flat_mule_weep(inputs)
});